import { MdOutlineDesignServices } from "react-icons/md";
import { MdOutlinePrint } from "react-icons/md";
import { RiTShirtAirLine } from "react-icons/ri";
import IMG_DSNG from "../../images/DSGN.jpeg"
import IMG_0827 from "../../images/IMG_0825.jpeg"
import IMG_0811 from "../../images/IMG_0811.jpeg"
export const PrjCards = [
  {
    // description: "Ferrari 2025 season Fan-Website",
    title: "გრაფიკული დიზაინი",
    icon: <MdOutlineDesignServices  />,
    src: IMG_DSNG,
    github: "",
    ctaText: "Visit",
    ctaLink: "https://ferraritifo.netlify.app/",
    content: () => {
      return (
        <p>
         გთავაზობთ პროფესიონალურ გრაფიკული დიზაინის მომსახურებას, 
         რომელიც მოიცავს ლოგოებს და სხვადასხვა ვიზუალური მასალების შექმნას.
          თუ გაქვთ იდეა, თუმცა არ გაქვთ დასრულებული დიზაინი ...
          <br /> <br />
        </p>
      );
    },
     content2: () => {
      return (
        <p>
         გთავაზობთ პროფესიონალურ გრაფიკული დიზაინის მომსახურებას, 
         რომელიც მოიცავს ლოგოებს და სხვადასხვა ვიზუალური მასალების შექმნას.
          თუ გაქვთ იდეა, თუმცა არ გაქვთ დასრულებული დიზაინი, ჩვენი გუნდი 
          დაგეხმარებათ მის სრულად განვითარებასა და ვიზუალურად გამართვაში — 
          როგორც ბიზნეს საჭიროებებისთვის, ასევე პერსონალური პროექტებისთვის.
          <br /> <br />
        </p>
      );
    },
  },
  {
    // description: "Georgia's tourist tour website",
    title: "DTF ბეჭვდა",
    icon: <MdOutlinePrint  />,
    src: IMG_0827,
    github: "",
    ctaText: "Visit",
    ctaLink: " ..",
    content: () => {
      return (
        <p>
         თანამედროვე ტექნოლოგია, რომელიც უზრუნველყოფს მკვეთრ ფერებს,
          მაღალი ხარისხის გამოსახულებას და გამძლე პრინტს სხვადასხვა ტიპის
           ქსოვილზე ...
          <br /> <br />
       
        </p>
      );
    },
    content2: () => {
      return (
        <p>
        თანამედროვე ტექნოლოგია, რომელიც უზრუნველყოფს მკვეთრ ფერებს,
        მაღალი ხარისხის გამოსახულებას და გამძლე პრინტს სხვადასხვა ტიპის ქსოვილზე.
          ის გამოირჩევა დეტალების სიზუსტითა და ხანგრძლივი გამოყენებისადმი მდგრადობით,
          რაც იდეალურს ხდის როგორც ყოველდღიური, ასევე პროფესიული დანიშნულებისთვის.
          <br /> <br />
       
        </p>
      );
    },
    
  },

  {
    // description: "a brand new online store",
    title: "ტანსაცმელი",
    icon: <RiTShirtAirLine />,
    src: IMG_0811,
    ctaText: "Visit",
    ctaLink: "https://musiccrafters.netlify.app/",
    content: () => {
      return (
        <p>
          გთავაზობთ მაღალი ხარისხის ტანსაცმლის ფართო არჩევანს — მაისურებს, ჰუდებს,
          პოლოს ტიპის მაისურებს და სხვა ტექსტილის პროდუქციას. 
          იდეალურია როგორც ინდივიდუალური შეკვეთებისთვის, ასევე კომპანიებისა
           და ბრენდებისთვის ...
          <br /> <br />
         
        </p>
      );
    },
    content2: () => {
      return (
        <p>
         გთავაზობთ მაღალი ხარისხის ტანსაცმლის ფართო არჩევანს — მაისურებს, ჰუდებს, 
         პოლოს ტიპის მაისურებს და სხვა ტექსტილის პროდუქციას. იდეალურია როგორც 
         ინდივიდუალური შეკვეთებისთვის, ასევე კომპანიებისა და ბრენდებისთვის, 
         რომლებიც ეძებენ კომფორტულ, გამძლე და ვიზუალურად დახვეწილ ტანსაცმელს.
          <br /> <br />
        </p>
      );
    },
  },
  
];
